import * as Edge from './../core';

export abstract class PermissionService {
	public static async getMyRoles(): Promise<Edge.Models.AssignedRoles> {
		const route = Edge.API.ServerRoute.forAction('users', 'me/roles');
		return await Edge.API.get(route);
	}
}
